import { BookingStatus, BOOKING_STATUS_LABEL } from "../constants";

export const BOOKING_LIST_STATUS_FILTER_OPTIONS = Object.values(BookingStatus).map((status) => ({
  label: BOOKING_STATUS_LABEL[status],
  value: status,
}));

export default BOOKING_LIST_STATUS_FILTER_OPTIONS;
